import { IChangeRouteAction } from './types';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
// eslint-disable-next-line import/no-cycle
import { getArchivedChatsV2 } from '../archivedList/getArchivedChatsV2';
import { getChatsV2 } from '../chatList/getChatsV2';
import { EInternetStatus } from '../internetStatus';
import { getSpamChatsV2 } from '../spamList/getSpamChatsV2';
import { getStarredChatsV2 } from '../starredChatsList/getStarredChatsV2';
import { getUnreadChatsV2 } from '../unreadList/getUnreadChatsV2';

export const changeRoute =
  ({ route, notClearCurrentOpenedChatId }: IChangeRouteAction): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();

    const { internetStatus } = state;
    if (internetStatus !== EInternetStatus.Online) {
      dispatch(showAlert({ message: 'Нет сети' }));

      return;
    }

    /**
     * При переходе в список сообщений запрашиваем и переписываем chatList в активные чаты
     */
    if (route === ERoute.Messages) {
      dispatch(getChatsV2({ notClearCurrentOpenedChatId }));
    }

    /**
     * При переходе в список непрочитанных сообщений запрашиваем без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из архива
     *  - ставим активный роут "Архив"
     */
    if (route === ERoute.Unread) {
      dispatch(getUnreadChatsV2({}));
    }

    /**
     * При переходе в спам
     *  - запрашиваем без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из спама
     *  - ставим активный роут "Спам"
     */
    if (route === ERoute.Spam) {
      dispatch(getSpamChatsV2({}));
    }

    /**
     * При переходе в архив
     *  - запрашиваем без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из архива
     *  - ставим активный роут "Архив"
     */
    if (route === ERoute.Archive) {
      dispatch(getArchivedChatsV2({}));
    }
    /**
     * При переходе в важные чаты
     *  - запрашиваем без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в важные чаты
     *  - ставим активный роут "Важные"
     */
    if (route === ERoute.Starred) {
      dispatch(getStarredChatsV2({}));
    }
  };
